<template>
  <div>
    <BrandCollect />
  </div>
</template>
<script>
import BrandCollect from "@/components/home/brand-collect.vue";
import { mapGetters } from "vuex";
export default {
  props: {},
  components: {
    BrandCollect,
  },
  mixins: [],
  data() {
    return {
      missionCustomStyle: {},
    };
  },
  async created() {
    // this.missionCustomStyle = this.getMissionCustomStyle(false);
  },
  destroyed() {},
  beforeDestroy() {},
  watch: {
    isDarkMode() {
      // this.missionCustomStyle = this.getMissionCustomStyle(false);
    },
  },
  computed: {
    ...mapGetters({
      // isDarkMode: "user/isDarkMode",
    }),
  },
  methods: {},
};
</script>
<style lang="scss">
</style>
